export function summarizeCareSupplies(rows) {
    return rows
        .map((row) => {
        assertSupply(row);
        const hasThreshold = typeof row.userReminderAt === 'number';
        const state = hasThreshold && row.remainingQuantity <= row.userReminderAt
            ? 'at_or_below_user_threshold'
            : 'counted';
        return {
            ...row,
            state,
            thresholdLabel: hasThreshold ? `${row.userReminderAt} ${row.unitLabel}` : null,
        };
    })
        .sort((left, right) => {
        if (left.state !== right.state)
            return left.state === 'at_or_below_user_threshold' ? -1 : 1;
        return left.name.localeCompare(right.name, 'ko');
    });
}
export function buildCarePreparationText(input) {
    const lines = [
        `${input.petName} 돌봄 준비 묶음`,
        `정리한 날: ${input.preparedOn}`,
        '아래 내용은 보호자가 직접 입력한 사실입니다.',
        '',
        '[관리 계획]',
        ...orEmpty(input.plans.map((plan) => `- ${plan.title} · ${plan.sourceLabel} · ${plan.sourceCheckedOn}`)),
        '',
        '[다음에 물어볼 것]',
        ...orEmpty(input.questions.map((question) => `- ${question.text} · ${question.askedOn}`)),
        '',
        '[이어진 기록 묶음]',
        ...orEmpty(input.eventGroups.map((group) => `- ${group.title} · ${[...group.dates].sort().join(', ')}`)),
        '',
        '[보호자가 센 재고]',
        ...orEmpty(summarizeCareSupplies(input.supplies).map((supply) => {
            const threshold = supply.thresholdLabel ? ` · 내가 정한 확인선 ${supply.thresholdLabel}` : '';
            return `- ${supply.name}: ${supply.remainingQuantity} ${supply.unitLabel} · ${supply.checkedOn} 확인${threshold}`;
        })),
    ];
    return lines.join('\n');
}
function orEmpty(lines) {
    return lines.length > 0 ? lines : ['- 기록 없음'];
}
function assertSupply(row) {
    if (!row.name.trim())
        throw new Error('supply name is required');
    if (!row.unitLabel.trim())
        throw new Error('supply unit is required');
    if (!Number.isFinite(row.remainingQuantity) || row.remainingQuantity < 0)
        throw new Error('remaining quantity is invalid');
    if (row.userReminderAt != null && (!Number.isFinite(row.userReminderAt) || row.userReminderAt < 0))
        throw new Error('user threshold is invalid');
    if (!/^\d{4}-\d{2}-\d{2}$/u.test(row.checkedOn))
        throw new Error('checkedOn must be an ISO date');
    if (row.checkedAt != null && (!Number.isFinite(row.checkedAt) || row.checkedAt < 0))
        throw new Error('checkedAt must be a valid time');
}
